module.exports = __webpack_public_path__ + "cfb671c494a9d9da197b35a3dedb3ec4.woff2";